import qoalaStorage from '~/core/Storage';

export default () => ({
  hcpData: JSON.parse(qoalaStorage.getItem('hcpData') || '{}'),
  listProduct: JSON.parse(qoalaStorage.getItem('hcpProduct')),
  productDetail: JSON.parse(qoalaStorage.getItem('productDetailHcp'))
});
